import { createAction } from 'redux-actions';

export default {
    UpdatePlanLuminaires: createAction('UPDATE_PLAN_LUMINAIRES'),
};
